import Global from '../../../store/global-selectors';
import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';

export const ProcessCanPurchaseLabelStep = (state, jobId) => {
  const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
  if (!jobData) {
    return [JobPipelineActions.exitJobPipeline(jobId)];
  }
  const { activeLabelStatusList } = jobData;
  const planIdsWithNoLabel = [];
  activeLabelStatusList.forEach((status) => {
    if (status.canPurchaseLabel) {
      planIdsWithNoLabel.push(status.fulfillmentPlanId);
    }
  });

  return [JobPipelineActions.updateJob(jobId, { planIdsWithNoLabel }), JobPipelineActions.goForwardOnJob(jobId)];
};
